<template>
  <div>

    <div class="card-toolbar-settings">
      <search-user></search-user>
    </div>

    <Toolbar v-if="getCashier || getType==4 || getTerminal"/>

    <LiveMatchTracker v-if="!this.checkIsMobile() && this.getCurrentPage == 'live_detail' && this.getEventsLiveDetail.length > 0"></LiveMatchTracker>

<!--    <BetInAcceptance></BetInAcceptance>-->

    <div class="card-toolbar-settings" v-if="!this.checkIsMobile()">
      <toolbar-settings :block="true" :small="false"></toolbar-settings>
    </div>

    <section style="display: flex; flex-direction: column; gap: 20px">
      <template v-for="section in orderedRightSections">

        <CartMarketView
            v-if="section.id === 'cart' && section.enabled"
            :key="'cart'" />

        <QuizBet
            v-if="section.id === 'quizbet' && section.enabled && !checkIsMobile() && getViewMode !== 'detail'"
            :key="'quizbet'" />

        <ImagesAds
            v-if="section.id === 'right_banners' && section.enabled"
            :key="'right_banners'" />

        <LatestWins
            v-if="section.id === 'last_wins' && section.enabled && !checkIsMobile()"
            :key="'last_wins'" />

      </template>

    </section>


  </div>
</template>

<script>
  import CartMarketView from "./right_widgets/CartMarketView";
  import ImagesAds from "./right_widgets/ImageAds";
  import { mapGetters } from "vuex";
  import BetInAcceptance from "@/components/right_widgets/BetInAcceptance";
  import ToolbarSettings from "./generic/ToolbarSettings";
  import SearchUser from "./generic/SearchUser";
  import { isMobileOnly } from "mobile-device-detect";
  import LoadingSkeleton from "@/components/generic/LoadingSkeleton";
  import { checkIsMobileDevice } from "@/plugins/device-inspector";
  import QuizBet from "@/components/generic/QuizBet.vue";
  import LatestWins from "@/components/right_widgets/LatestWins.vue";

  const LiveMatchTracker = () => ({
    component: import('@/components/right_widgets/LiveMatchTracker'),
    loading: LoadingSkeleton,
    timeout: 200
  })

  import Toolbar from "@/components/generic/Toolbar.vue";

  export default {
    name: 'Right',
    components: {
      QuizBet,
      BetInAcceptance,
      LoadingSkeleton,
      LiveMatchTracker,
      ImagesAds,
      CartMarketView,
      ToolbarSettings,
      SearchUser,
      LatestWins,
      Toolbar
    },
    data: () => ({
      isMobileOnly: isMobileOnly,
    }),
    computed: {
      ...mapGetters({
        'getGameConsole': 'settings/getGameConsole',
        'getViewMode': 'ui/getViewMode',
        'getCurrentPage': 'sportNavigation/currentPage',
        'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
        'getBet': 'cart/getBet',
        'getType': 'user/getType',
        'getCashier': 'user/getCashier',
        'getUiPersonalizationRight': 'settings/getUiPersonalizationRight',
        'getTerminal': 'user/getTerminal'
      }),

      orderedRightSections() {
        const config = this.getUiPersonalizationRight
        if (!config) {
          return [
            { id: 'cart',          enabled: true, order: 1 },
            { id: 'quizbet',       enabled: true, order: 2 },
            { id: 'right_banners', enabled: true, order: 3 },
            { id: 'last_wins',     enabled: true, order: 4 },
          ]
        }
        return [...config].sort((a, b) => a.order - b.order)
      },
    },
    methods: {
      checkIsMobile() {
        return checkIsMobileDevice()
      },
    }
  };
</script>
